<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li class="flex items-center">
              <router-link to="/systemHooks" class="mr-2 vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
              <h3>{{ $t("system.label.EditEventActionMapping") }}</h3>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.Event")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Event')"
                >
                  <v-select
                    label="mCodeValue"
                    disabled
                    v-model="createEventMap.event"
                    :options="eventList"
                    @input="eventsSelected()"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.Action")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Action')"
                >
                  <v-select
                    label="mCodeValue"
                    disabled
                    v-model="createEventMap.action"
                    :options="actionList"
                    @input="actionSelected()"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.Process')"
              >
                <vs-input
                  :label="$t('system.label.Process')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="createEventMap.process"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.OrderBy")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.OrderBy')"
                >
                  <v-select
                    label="text"
                    v-model="createEventMap.orderBy"
                    :options="orderByList"
                    :reduce="(text) => text.value"
                    @input="orderBYselected()"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    class="w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.ExternalSystem")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ExternalSystem')"
                >
                  <v-select
                    label="text"
                    v-model="createEventMap.externalSystem"
                    :options="externalSystemData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    class="w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.PrePost")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.PrePost')"
                >
                  <v-select
                    label="text"
                    v-model="createEventMap.prePost"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :options="prePostShow"
                    :reduce="(text) => text.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                v-model="createEventMap.issynchronous"
                >{{ $t("system.label.AutoGenerate") }}</vs-checkbox
              >
            </div>
            <div class="vx-col w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("system.label.ProcessParams")
                }}</small>

                <vs-textarea v-model="createEventMap.processParams" />
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="editSubmitEventAction"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";

const createEventMapEmptyObj = {
  event: "",
  action: "",
  orderBy: "",
  prePost: "",
  issynchronous: false,
  processParams: "",
  externalSystem: "",
  process: "workflow_events",
};
export default {
  data() {
    return {
      breadcrumbs: [
        { name: "System", to: "" },
        { name: this.$t("reports.label.Hooks"), to: "/systemHooks" },
        { name: this.$t("system.label.EditEventActionMapping"), to: "/" },
      ],
      createEventMap: createEventMapEmptyObj,
      eventList: [],
      actionList: [],
      externalSystemData: [],
      orderByList: [
        { text: "0", value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
      ],
      prePostList: [],
      prePostShow: [
        { text: "Pre", value: false },
        { text: "Post", value: true },
      ],
      actionName: "",
      eventName: "",
      is_synchronous: "",
      isDeleted: "",
      externalSystem: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapGetters({ editEventAction: "system/getEditEventActionData" }),
  },
  methods: {
    async editEventActionDataById() {
      try {
        this.$store
          .dispatch("configuration/setEditEventAction", this.$route.params.id)
          .then((response) => {
            this.createEventMap.event = response.data.eventName;
            this.createEventMap.action = response.data.actionName;
            this.createEventMap.process = response.data.process;
            this.createEventMap.orderBy = response.data.orderBy;
            this.createEventMap.prePost = response.data.prePost;
            this.createEventMap.issynchronous = response.data.issynchronous;
            this.createEventMap.processParams = response.data.processParams;
            this.createEventMap.externalSystem = response.data.externalSystem;
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editSubmitEventAction() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const resp = await this.$store.dispatch(
          "configuration/editSubmitEventActionAction",
          { id: this.$route.params.id, data: this.createEventMap }
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Currency Exchange Created Successfully!",
          type: "success",
        });
        if (resp.status == 200) {
          this.$router.push({
            path: `/viewEventAction/${this.$route.params.id}`,
          });
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating entity:", e);
      }
    },
    async getEventActionData() {
      try {
        const response = await this.$store.dispatch(
          "configuration/getCreateSetEventActionTemplate"
        );
        this.data = response.data;

        response.data.eventData.forEach((element) => {
          this.eventList.push(element.mCodeValue);
        });
        response.data.actionData.forEach((element) => {
          this.actionList.push(element.mCodeValue);
        });
        this.externalSystemData = response.data.externalSystemData;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },

    resetForm() {
      this.createEventMap = createEventMapEmptyObj;
      (this.createEventMap.event = ""),
        (this.createEventMap.action = ""),
        (this.createEventMap.orderBy = ""),
        (this.createEventMap.prePost = false),
        (this.createEventMap.processParams = "");
    },
    cancel() {
      this.$router.push("/systemHooks");
    },
  },

  mounted() {
    this.getEventActionData();
    this.editEventActionDataById();
  },
};
</script>
